<template>
  <v-container>
    <v-row>
      <v-col>
        <span class="d-flex flex-row align-center">
          <v-btn text class="mx-2" @click="()=>{this.$router.go(-1)}">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <h1>{{plural}}</h1>
          <v-btn class="ml-2" color="info" small fab @click="showCreateMenu"><v-icon>mdi-plus</v-icon></v-btn>
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2">
        <v-data-table
          outlined
          :headers="headers"
          :items="allData"
          :search="tailorSearch"
          :items-per-page="-1"
          class="elevation-1"
          single-select
          :loading="loader"
          @click:row="rowClick"
        >
          <template v-slot:top>
            <v-text-field
                v-model="tailorSearch"
                label="Search..."
                class="mx-4"
            ></v-text-field>
          </template>
        </v-data-table>
      </v-col>
      <v-col v-if="this.showAddNew">
        <v-card  outlined>
          <v-card-title>
            <span>Add New {{singular}}</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="createForm" v-model="validCreate">
              <v-text-field outlined type="text" label="Name" v-model="formData.name" :rules="rules.required"/>
              <v-text-field outlined type="text" label="Phone" v-model="formData.phone" :rules="rules.required"/>
              <v-text-field outlined type="text" label="Shortname" v-model="formData.metadata.shortName" :rules="rules.required"/>
              <v-checkbox label="Hide From Lists?" v-model="formData.metadata.hide"/>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="closeMenu" color="error" >Cancel</v-btn>
            <v-btn :loading="createLoading" @click="create" color="success" :disabled="!validCreate||createLoading" >Create</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="10" v-if="showSelected && selectedRow">
        <v-card outlined class="mb-2">
          <v-card-title class="d-flex flex-row">
            <span>Showing: {{singular}} #{{selectedRow.id}} ({{selectedRow.name}})</span>
            <v-btn v-if="!this.isEditable" @click="isEditable=true" class="ml-2" fab x-small color="info"><v-icon>mdi-pencil</v-icon></v-btn>
            <v-btn v-if="this.isEditable" @click="isEditable=false" class="ml-2" fab x-small color="error"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <span v-if="isEditable">
            <v-card-text>
              <v-form v-model="validCreate">
                <v-text-field outlined type="text" label="Name" v-model="selectedRow.name" :rules="rules.required"/>
                <v-text-field outlined type="text" label="Phone" v-model="selectedRow.phone" :rules="rules.required"/>
                <v-text-field outlined type="text" label="Shortname" v-model="selectedRow.metadata.shortName" :rules="rules.required"/>
                <v-checkbox label="Hide From Lists?" v-model="selectedRow.metadata.hide"/>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn @click="saveChanges" color="success">Save Changes</v-btn>
            </v-card-actions>
          </span>
        </v-card>
        <v-card class="mb-2" outlined>
          <v-card-text>
            <v-row>
              <v-col class="pa-3 ma-3" style="border: 1px solid grey; border-radius: 3px;">
                <h2>Totals</h2>
                <div class="d-flex flex-row justify-space-between">
                  <b>Current Total Jobs Sent</b>
                  <span>{{this.jobsTableItems.filter(x=>parseJobStatus(x.status)=='Sent').length}} ({{((this.jobsTableItems.filter(x=>parseJobStatus(x.status)=='Sent').length/this.allJobs.filter(x=>parseJobStatus(x.status)=='Sent').length)*100).toFixed(2)}}%)</span>
                </div>
                <div class="d-flex flex-row justify-space-between">
                  <b>Current Total Jobs Received</b>
                  <span>{{this.jobsTableItems.filter(x=>parseJobStatus(x.status)=='Received').length}} ({{parseFloat((this.jobsTableItems.filter(x=>parseJobStatus(x.status)=='Received').length/this.allJobs.filter(x=>parseJobStatus(x.status)=='Received').length)*100).toFixed(2)}}%)</span>
                </div>
                <div class="d-flex flex-row justify-space-between">
                  <b>Current Total Jobs Collected</b>
                  <span>{{this.jobsTableItems.filter(x=>parseJobStatus(x.status)=='Completed').length}} ({{parseFloat((this.jobsTableItems.filter(x=>parseJobStatus(x.status)=='Completed').length/this.allJobs.filter(x=>parseJobStatus(x.status)=='Completed').length)*100).toFixed(2)}}%)</span>
                </div>
                <div class="d-flex flex-row justify-space-between">
                  <b>Current Total Jobs Voided</b>
                  <span>{{this.jobsTableItems.filter(x=>parseJobStatus(x.status)=='Voided').length}} ({{parseFloat((this.jobsTableItems.filter(x=>parseJobStatus(x.status)=='Voided').length/this.allJobs.filter(x=>parseJobStatus(x.status)=='Voided').length)*100).toFixed(2)}}%)</span>
                </div>
              </v-col>
              <v-col class="pa-3 ma-3" style="border: 1px solid grey; border-radius: 3px;">
                <h2>Ratios</h2>
                <div class="d-flex flex-row justify-space-between">
                  <b>Jobs done by Tailor/All Jobs</b>
                  <span>{{((this.jobsTableItems.length/this.allJobs.length)*100).toFixed(2)}}%</span>
                </div>
                <div class="d-flex flex-row justify-space-between">
                  <b>Profit Earned/All Profits</b>
                  <span>{{parseFloat((((this.jobsTableItems.reduce((acc,x)=>acc+((!!x.totalCost?parseFloat(x.totalCost):0)-(!!x.tailorCost?parseFloat(x.tailorCost):0)),0))/(this.allJobs.reduce((acc,x)=>acc+((!!x.totalCost?parseFloat(x.totalCost):0)-(!!x.tailorCost?parseFloat(x.tailorCost):0)),0))))*100).toFixed(2)}}%</span>
                </div>
                <div class="d-flex flex-row justify-space-between">
                  <b>Profit / Work Done Index (Larger is better)</b>
                  <span>{{parseFloat((parseFloat((((this.jobsTableItems.reduce((acc,x)=>acc+((!!x.totalCost?parseFloat(x.totalCost):0)-(!!x.tailorCost?parseFloat(x.tailorCost):0)),0))/(this.allJobs.reduce((acc,x)=>acc+((!!x.totalCost?parseFloat(x.totalCost):0)-(!!x.tailorCost?parseFloat(x.tailorCost):0)),0))))*100).toFixed(2))/((this.jobsTableItems.length/this.allJobs.length)*100).toFixed(2)).toFixed(2)}}</span>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card outlined>
          <v-card-title>Jobs done by {{selectedRow.name}}</v-card-title>
          <v-data-table
            outlined
            :headers="jobsTableHeaders"
            :items="jobsTableItems"
            :items-per-page="-1"
            class="elevation-1"
            :loading="jobsTableLoader"
            @click:row="viewJobRow"
          >
            <template v-slot:item.status="{ item }">
              <span>{{ parseJobStatus(item.status) }}</span>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </v-container>
</template>
<script>
import axios from 'axios';
import {mapGetters} from "vuex";
import moment from "moment";
export default {
  data () {
    return {
      isEditable: false,
      createLoading: false,
      snackObj: {
        color: '',
        text: ''
      },

      rules: {
        required: [v => !!v || 'This field is required.'],
      },
      validCreate: false,

      tailorSearch: "",

      loader: false,
      jobsTableLoader: true,
      headers: [
        { text: 'Name', sortable: false, value: 'name' },
      ],
      jobsTableHeaders: [
        { text: 'Status', value: 'status' },
        { text: 'ID', align: 'start', sortable: true, value: 'id' },
        { text: 'Customer', sortable: true, value: 'customer' },
        { text: 'Item', sortable: true, value: 'item' },
        { text: 'Date Out', sortable: true, value: 'out' },
        { text: 'Date In', sortable: true, value: 'in' },
        { text: '$C', sortable: true, value: 'totalCost' },
        { text: '$T', sortable: true, value: 'tailorCost' },
        { text: '$R', sortable: true, value: 'revenue' },
      ],
      allData: [],
      formData: {
        metadata: {}
      },
      allJobs: [],
      selectedRow: null,
      showAddNew: false,
      showSelected: true,
      pluralLower: "tailors",
      plural: "Tailors",
      singularLower: "tailor",
      singular: "Tailor",
      jobsTableItems: [],
    }
  },
  async mounted(){
    if(!this.isAllowed('job', 'viewRevenue')) {
      this.jobsTableHeaders.splice(8,1)
      this.jobsTableHeaders.splice(7,1)
    }
    await this.getAllData();
  },
  computed: {
    ...mapGetters(['getEndpoint', 'isAllowed']),
  },
  methods: {
    parseJobStatus(id){
      if(id===-1) return "Voided"
      else if(id===0) return "New"
      else if(id===1) return "Sent"
      else if(id===2) return "Received"
      else if(id===3) return "Completed"
    },
    parseDate(date){
      if(!date) return null;
      return moment(this.parseISODate(date)).format("DD/MM/YYYY")
    },
    momentDateFormat (date) {
      return date ? moment(this.parseISODate(date)).format('ddd, MMM Do YYYY') : '';
    },
    parseISODate(date){
      return (date?new Date(date).toISOString().substring(0, 10):null);
    },
    snack(text, color=""){
      this.snackObj.text = text;
      this.snackObj.color = color;

      this.$refs.snackbar.openDialog();
    },
    async create(){
      try {
        this.createLoading = true
        let res = await axios.post(`${this.getEndpoint}/api/${this.pluralLower}`, this.formData)
        if(res.data.error) throw res.data.error;
        if(res.data.data.created) this.snack(`${this.singular} Created 🎉`);
        else this.snack(`${this.singular} already exists.`);
        await this.getAllData(res.data.data.id);
      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      } finally {
        this.formData = {metadata:{}};
        // this.$refs.createForm.reset()
        this.createLoading = false
      }
    },
    async getAllData(id=null){
      try {
        this.loader = true;

        if(!id && this.$route.query && this.$route.query.selected){
          id = parseInt(this.$route.query.selected);
        }
        let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}`)
        let jobs = await axios.get(`${this.getEndpoint}/api/jobs`)
        this.allJobs =  jobs.data.data
        if(res.data.error) throw res.data.error;
        this.allData = res.data.data
        if(this.allData.length>0){
          this.allData.forEach(t=>!t.metadata?t.metadata = {} : false)
          if(id){
            this.selectedRow = this.allData.find(x=>x.id===id)
            if(!this.selectedRow) throw `Could not find ${this.singular}`;
          }
          else{
            this.selectedRow = this.allData[0];
          }
          if(!id && this.$route.query.create){
            this.showSelected = false
            this.showAddNew = true
          }
          else{
            if(!(this.$route.query.selected && this.$route.query.selected==this.selectedRow.id)){
              await this.$router.replace({path: `/${this.pluralLower}`, query: {selected: this.selectedRow.id}})
            }
            this.showSelected = true
            this.showAddNew = false
          }
          await this.loadJobTableData()
        }
      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      } finally {
        this.loader = false;
      }
    },
    viewJobRow(row){
      this.$router.push(`/jobs?selected=${row.id}`)
    },
    async rowClick(item, row){
      row.select(true);
      this.selectedRow = item;

      if(!(this.$route.query.selected && this.$route.query.selected==item.id)){
        await this.$router.replace({path: `/${this.pluralLower}`, query: {selected: item.id}})
      }
      await this.loadJobTableData()
      this.showAddNew = false;
      this.showSelected = true;

      window.scrollTo(0, 0);
    },
    async showCreateMenu(){
      if(!(this.$route.query.create)){
        await this.$router.push({path: `/${this.pluralLower}`, query: {create: "true"}})
      }
      this.formData = {metadata:{}};
      this.showSelected = false;
      this.showAddNew = true;
      // this.$refs.createForm.reset()
    },
    async closeMenu(){
      this.showSelected = true;
      this.showAddNew = false;
      await this.$router.go(-1)
    },
    async loadJobTableData(){
      try {        
        if(!this.selectedRow) return
        this.jobsTableLoader = true
        let tailorData = await axios.get(`${this.getEndpoint}/api/jobs/tailor/${this.selectedRow.id}`)
        this.jobsTableItems = tailorData.data.data

        this.jobsTableItems.forEach(x=>{
          x.customer = x.Item.Customer.firstName + " " + x.Item.Customer.lastName
          x.item = x.Item.Asset.styleNo +(x.Item.colour?" ("+x.Item.colour+")":'')
          x.in = this.momentDateFormat(x.dateIn)
          x.out = this.momentDateFormat(x.dateOut)
          x.hand = this.momentDateFormat(x.handedOffAt)
          x.revenue = x.totalCost-x.tailorCost
        })
      } catch (error) {
        this.snack(error)
        console.log(error)
      } finally {
        this.jobsTableLoader = false
      }
    },
    async saveChanges(){
      try {
        let obj = {
          ...this.selectedRow
        }
        let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/${this.selectedRow.id}`, obj)
        if(res.data.error) throw res.data.error;
        this.snack("Success!")
      } catch (error) {
        this.snack(error)
      }
    },
  }
}
</script>
